import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
/**
 * @typedef {object} ComponentsChallengesLinkProps
 * @property {unknown} adminLayout
 * @property {unknown} challenge
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsChallengesLinkState */

/**
 * @extends {ShapeComponent<ComponentsChallengesLinkProps, ComponentsChallengesLinkState>}
 */
class ComponentsChallengesLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    challenge: instanceOfClassName("Challenge").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, challenge, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--challenges--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || challenge.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || challenge.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, challenge} = this.p

    if (adminLayout) return Routes.adminChallengePath(challenge.id())
  }
}

export default memo(shapeComponent(ComponentsChallengesLink))
